module.exports = __webpack_public_path__ + "c5fdd6e71524d05f6df5791e56f6b09b.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/header/shaffi11-xlarge.jpg
// module id = UdZ4
// module chunks = 0